"use client";

import { PageCareerOverviewSchema } from "@/sanity/pages/PageCareerOverviewTemplate";

import Footer from "../global/partials/Footer";
import HeaderV2 from "../global/partials/HeaderV2";
import ApplicationProcessSection from "../pageComponents/careers/ApplicationProcessSection";
import BenefitsSection from "../pageComponents/careers/BenefitsSection";
import CareerIntroSection from "../pageComponents/careers/CareerIntroSection";
import CareerOverviewHero from "../pageComponents/careers/CareerOverviewHero";
import CareerStatsSection from "../pageComponents/careers/CareerStatsSection";
import CareerTeamSection from "../pageComponents/careers/CareerTeamSection";
import JobListSection from "../pageComponents/careers/JobListSection";
import ScrollingBanner from "../pageComponents/global/ScrollingBanner";
import FaqSection from "../pageComponents/global/sections/FaqSection";
import DesignScaleLock from "../global/DesignScaleLock";

export default function PageCareerOverviewJSX({ data }: { data: PageCareerOverviewSchema }) {
  const settings = data.careerSettings;

  const finalCta = data.finalCtaTitle
    ? {
        finalCtaChip: data.finalCtaChip,
        finalCtaTitle: data.finalCtaTitle,
        finalCtaButton: data.finalCtaButton,
        finalCtaImage: data.finalCtaImage,
      }
    : settings;

  return (
    <main className="flex flex-col items-center">
      <DesignScaleLock />
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType="main"
          language={data.settings?.language}
        />
      )}
      <CareerOverviewHero data={data} />
      <ScrollingBanner
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />
      <CareerStatsSection data={data} />
      <CareerIntroSection data={data} />
      <BenefitsSection data={settings} />
      <JobListSection data={data} />
      <CareerTeamSection data={data} />
      <ApplicationProcessSection data={settings} />
      {settings && (
        <FaqSection
          className="py-[8rem] lg:py-[15rem] max-lg:[&_button[data-state=open]]:pb-[1.35rem] max-lg:[&_svg]:h-[1.5rem] max-lg:[&_svg]:w-[1.5rem] max-lg:[&>div]:gap-[4rem] lg:[&>div]:gap-[5rem]"
          data={settings}
        />
      )}
      {data?.settings?.footer && <Footer data={data.settings?.footer} finalCta={finalCta} showTrustpilot={false} wideFinalCtaTitle language={data?.settings?.language} />}
    </main>
  );
}
